import { BigNumber } from '@0x/utils'
import assetUtils, { Asset } from 'app-lib/assetUtils'
import { AnyProvider } from './providerUtils'

const getAvailableLiquidity = async (provider: AnyProvider, asset: Asset): Promise<BigNumber> => {
  let result = new BigNumber(0)

  if (provider.contractsSource && provider.web3Wrapper) {
    const iTokenContract = provider.contractsSource.getITokenContract(asset)
    if (iTokenContract) {
      const decimals = assetUtils.getDecimals(provider.currentChainId, asset)
      const totalAssetSupply = await iTokenContract.totalAssetSupply().callAsync()
      const totalAssetBorrow = await iTokenContract.totalAssetBorrow().callAsync()

      const marketLiquidity = totalAssetSupply.minus(totalAssetBorrow)
      result = marketLiquidity.div(10 ** decimals)
    }
  }

  return result
}

export default {
  getAvailableLiquidity,
}
